import { EventDispatcher } from '@utils/toolbox';
import { ConnectApi } from '@js/plugins/connectApi';
// import dummyData from '@js/constants/flights.json';


// Useful for testing offline behavior during development
// let isOffline = false;
// window.addEventListener('keydown', function (e) {
// 	if (e.altKey && e.code === 'KeyO') {
// 		isOffline = !isOffline;
// 		alert(isOffline ? 'Offline' : 'Online');
// 	}
// });

export const resultsFetcher = {
	activeRequest: null,
	isLoading: false,
	isError: false,
	get (searchParameters) {
		this.isLoading = true;
		return new Promise((resolve, reject) => {
			// Cancel on going request
			this.activeRequest?.abort?.();

			const errorCallback = (error) => {
				console.trace(error);
				this.isError = true;
				this.isLoading = false;
				reject(error);
			};

			// Useful for testing offline behavior during development
			// if (isOffline) {
			// 	return errorCallback(new Error('ForcedNetworkError'));
			// }

			// Make new request using searchParams
			this.activeRequest = ConnectApi('Search', 'getResult', [searchParameters]).then((data) => {
				if (data?.error) {
					return errorCallback(data);
				}

				if (data?.debug && data.debug.numberOfFlights) {
					EventDispatcher.dispatch('debug:add', 'number_of_flights', data.debug.numberOfFlights);
				}

				this.isLoading = false;
				this.isError = false;
				// resolve(dummyData);
				resolve(data);
			}).catch(errorCallback);
			return this.activeRequest;
		});
	}
};

window.resultsFetcher = resultsFetcher;
